import React, { Component } from "react";
import Button from "@material-ui/core/Button";

function StackSelector(props) {
  let divStyle = {
    position: "absolute",
    bottom: "10px",
    zIndex: 10,
    ...props.style
  };

  let leftside = props.side == "left";
  let right = "";

  if (leftside) {
    divStyle.left = "10px";
  } else {
    divStyle.right = "10px";
  }
  const style = {
    margin: 12
  };
  let buttons = props.stacks.map(b => {
    return (
      <Button
        variant="contained"
        label={b.name}
        color={b.id === props.current ? "primary" : "default"}
        key={b.id}
        style={style}
        onClick={() => props.onChange(b.id)}
      >
        {b.name}
      </Button>
    );
  });

  return <div style={divStyle}>{buttons}</div>;
}

export default StackSelector;
